export default defineNuxtPlugin(() => {
  return {
    provide: {
      truncate: (val: string, n: number) => {
        return val.length > n ? val.slice(0, n) + "..." : val
      },
      highlightMatch: (subject: string, pattern: string): string => {
        if (pattern && pattern.search(/[^a-zA-Z 0-9,.]/gi) > -1) {
          return subject
        } else {
          return subject.replace(new RegExp(pattern, "gi"), "<strong>$&</strong>")
        }
      }
    }
  }
})
